/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Date format for the datetime picker.
 */
export const PICKER_DATE_FORMAT = `YYYY/MM/DD`;

/**
 * Time format for the datetime picker.
 */
export const PICKER_TIME_FORMAT = `HH:mm:ss`;

/**
 * Datetime format for the datetime picker.
 */
export const PICKER_DATETIME_FORMAT = `YYYY/MM/DD HH:mm:ss`;

/**
 * Delimiter to separate start and end range.
 */
export const PICKER_RANGE_DELIMITER = ` to `;
